<!-- home.component.html -->
<!-- Hero Section -->
<div class="container mt-5">
  <div class="jumbotron text-center bg-light p-5 rounded">
    <h1 class="display-4">Welcome to DemBeck Coding</h1>
    <p class="lead">Professional web development solutions tailored for your business needs.</p>
    <a class="btn btn-primary btn-lg" routerLink="/billing-form" role="button">Get Started</a>
  </div>
</div>

<!-- Features Section -->
<div class="container mt-5">
  <h2 class="text-center mb-4">Why Choose Us?</h2>
  <div class="row">
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">Custom Web Design</h5>
          <p class="card-text">We craft unique, responsive websites that leave a lasting impression.</p>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">Dynamic Web Apps</h5>
          <p class="card-text">Interactive applications powered by robust APIs and scalable solutions.</p>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="card h-100">
        <div class="card-body">
          <h5 class="card-title">Top-notch Maintenance</h5>
          <p class="card-text">Reliable maintenance plans to ensure your website runs smoothly.</p>
        </div>
      </div>
    </div>
  </div>
</div>
